const hideWhenSiteIsFIT = variables => variables.selectedSites?.every(site => site.contract_id === "FIT");
const hideWhenSelectedCountryIsNotAll = variables => variables.selectedCountry !== 'ALL'
const hideWhenSiteIsSolo = variables => variables.selectedSites?.every(site => site.solo);
const hideWhenClientAndSiteIsSolo = variables => variables.user?.roles?.includes("_CLIENT:Base") && variables.selectedSites?.every(site => site.solo);
const hideAllUsersExceptVN_OM = variables => !variables.user?.roles?.includes("administration:DataDownload:dailyIncidences:_view");
const hideWhenSiteIsNotBESS = variables => !variables.selectedSites?.every(site => site.is_BESS);
const hideWhenSiteIsNotPV = variables => variables.selectedSites?.every(site => site.is_no_PV);
const hideAllUsersExceptVN_OM_or_SiteIsNotPV = variables => !variables.user?.roles?.includes("administration:DataDownload:dailyIncidences:_view") || variables.selectedSites?.some(site => site.is_no_PV);
const hideWhenNoneOMUser = variables => !variables.user?.roles?.some(role => role.includes("_GY:O&M"));
const hideWhenNoneConsUser = variables => !variables.user?.roles?.some(role => role.includes("_GY:PM") || role.includes("_GY:Contractor"));
const hideWhenBESSNoneEDMI = variables => !variables.selectedSites?.some(site => site.is_BESS && site.BESS_meter_type === "EDMI")
const hideWhenBESSEDMI = variables => !variables.selectedSites?.some(site => site.is_BESS && site.BESS_meter_type !== "EDMI")

export default {
	hideWhenSiteIsFIT,
	hideWhenSelectedCountryIsNotAll,
	hideWhenSiteIsSolo,
	hideWhenClientAndSiteIsSolo,
	hideAllUsersExceptVN_OM,
	hideWhenSiteIsNotBESS,
	hideWhenSiteIsNotPV,
	hideAllUsersExceptVN_OM_or_SiteIsNotPV,
	hideWhenNoneOMUser,
	hideWhenNoneConsUser,
	hideWhenBESSNoneEDMI,
	hideWhenBESSEDMI
};